import React from 'react';
import useHelp from './useHelp';
import Loader from '../../components/Loader';

const Help: React.FC = () => {
    const {
        helpData,
        handleChange,
        handleAdd,
        handleDelete,
        handleSave,
        handleImageUpload,
        loading,
    } = useHelp();

    if(loading){
        return <Loader/>
    }

    return (
        <div className="container mx-auto p-6 bg-gray-100 rounded-lg shadow-lg">
            <div className="mb-10">
                <h2 className="text-3xl font-bold mb-6 text-gray-800">FAQ</h2>
                {helpData && helpData?.faq && Array.isArray(helpData?.faq) && helpData?.faq.map((faq, index) => (
                    <div key={index} className="mb-6 p-4 bg-white rounded-lg shadow-md">
                        <strong className="block text-lg mb-2">Question {index + 1}</strong>
                        <input
                            type="text"
                            placeholder="Question"
                            value={faq.question}
                            onChange={(e) => handleChange('faq', index, 'question', e.target.value)}
                            className="border p-3 mb-4 w-full rounded-lg"
                        />
                        <strong className="block text-lg mb-2">Answer {index + 1}</strong>
                        <input
                            type="text"
                            placeholder="Answer"
                            value={faq.answer}
                            onChange={(e) => handleChange('faq', index, 'answer', e.target.value)}
                            className="border p-3 mb-4 w-full rounded-lg"
                        />
                        <button onClick={() => handleDelete('faq', index)} className="bg-red-500 text-white p-2 rounded-lg">Delete</button>
                    </div>
                ))}
                <button onClick={() => handleAdd('faq')} className="bg-blue-500 text-white p-3 rounded-lg">Add More FAQs</button>
            </div>

            <div className="mb-10">
                <h2 className="text-3xl font-bold mb-6 text-gray-800">Contact Us</h2>
                {helpData && helpData?.contactUs && Array.isArray(helpData?.contactUs) && helpData?.contactUs.map((contact, index) => (
                    <div key={index} className="mb-6 p-4 bg-white rounded-lg shadow-md">
                        <strong className="block text-lg mb-2">Image</strong>
                        <input
                            type="file"
                            onChange={(e) => handleImageUpload(e, index)}
                            className="border p-3 mb-4 w-full rounded-lg"
                        />
                        {contact.image && <img src={contact.image} alt="Contact" className="mb-4 w-30 h-30 rounded-lg" />}
                        <strong className="block text-lg mb-2">Name</strong>
                        <input
                            type="text"
                            placeholder="Name"
                            value={contact.name}
                            onChange={(e) => handleChange('contactUs', index, 'name', e.target.value)}
                            className="border p-3 mb-4 w-full rounded-lg"
                        />
                        <strong className="block text-lg mb-2">URL</strong>
                        <input
                            type="text"
                            placeholder="URL"
                            value={contact.url}
                            onChange={(e) => handleChange('contactUs', index, 'url', e.target.value)}
                            className="border p-3 mb-4 w-full rounded-lg"
                        />
                        {contact.url && <a href={contact.url.startsWith('https://') ? contact.url : `https://${contact.url}`} 
                        target="_blank" rel="noopener noreferrer" className="text-blue-500 block mb-4 hover:underline hover:text-blue-700">
                            URL Preview
                        </a>}
                        <button onClick={() => handleDelete('contactUs', index)} className="bg-red-500 text-white p-2 rounded-lg">Delete</button>
                    </div>
                ))}
                <button onClick={() => handleAdd('contactUs')} className="bg-blue-500 text-white p-3 rounded-lg">Add More Contact Details</button>
            </div>

            <button onClick={handleSave} className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 
            rounded block w-4/5 md:w-1/5 mx-auto mb-4 fixed bottom-2 ml-[36rem] transform -translate-x-1/2">
                Save
            </button>
        </div>
    );
};

export default Help;
